export { FeaturedPillar } from './FeaturedPillar';
